import useNavigation from 'core/hooks/useNavigation'
import { useEffect, useState } from 'react'

type SectionType =
  | 'dashboard'
  | 'settings'
  | 'team-dashboard'
  | 'team-settings'
  | 'program-detail'
  | 'member-detail'
  | 'member-invite'
  | 'onboarding'
  | 'schedule-new'

const usePathSection = () => {
  const { pathname } = useNavigation()
  const [section, setSection] = useState<SectionType>()

  const [isTeamSpace, setTeamSpace] = useState<boolean>(
    !pathname.includes('/dashboard')
  )

  useEffect(() => {
    if (
      pathname.includes('dashboard') ||
      pathname.includes('accountants') ||
      pathname.includes('teams-features')
    ) {
      setTeamSpace(false)
      return setSection('dashboard')
    }

    if (pathname === '/teams/members/new') {
      setTeamSpace(true)
      return setSection('member-invite')
    }

    if (pathname.includes('/teams/members/')) {
      setTeamSpace(true)
      return setSection('member-detail')
    }

    if (pathname.includes('teams') || pathname.includes('teams/members/new')) {
      setTeamSpace(true)
      return setSection('team-dashboard')
    }

    if (pathname.includes('program/')) {
      setTeamSpace(true)
      return setSection('program-detail')
    }

    if (pathname.includes('/schedules/new')) {
      setTeamSpace(true)
      return setSection('schedule-new')
    }

    if (pathname.includes('account/team')) {
      setTeamSpace(false)
      return setSection('settings')
    }

    if (pathname.includes('team')) {
      setTeamSpace(true)
      return setSection('team-settings')
    }

    if (pathname.includes('account')) {
      setTeamSpace(false)
      return setSection('settings')
    }

    if (
      [
        '/about-you',
        '/step-one',
        '/step-two',
        '/step-three',
        '/create-team',
        '/invite-members'
      ].includes(pathname)
    ) {
      setTeamSpace(false)
      return setSection('onboarding')
    }

    setTeamSpace(false)
    setSection('dashboard')
  }, [pathname])

  return {
    section,
    isTeamSpace
  }
}

export default usePathSection
